import { IV1SearchOffersForHouseCardMobileSiteResponseSchema } from 'shared/repositories/search-engine/entities/response/V1SearchOffersForHouseCardMobileSiteResponseSchema';
import { initialState } from 'shared/slices/offers/initialState';
import { EOffersStatus, IOffersMobile } from 'shared/types/offers';

export const prepareMobileOffers = (response: IV1SearchOffersForHouseCardMobileSiteResponseSchema) => {
  const data = response as IOffersMobile;

  return {
    data: { ...initialState.data, ...data },
    status: EOffersStatus.Ready,
  };
};
